<template>
  <div class="et-switch">
    <label>
      <input type="radio" ref="activeRef" name="groundSwitch" @click="onClickActive">
      <span>{{ activeText }}</span>
    </label>
    <label>
      <input type="radio" ref="inActiveRef" name="groundSwitch" @click="onClickInactive">
      <span>{{ inactiveText }}</span>
    </label>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch, watchEffect } from 'vue'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  activeText: {
    type: String,
    default: '闭合'
  },
  inactiveText: {
    type: String,
    default: '断开'
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
    emit('change', val)
  }
})
const activeRef = ref(null)
const inActiveRef = ref(null)

onMounted(() => {
  watch(value, (val) => {
    if (val) {
      activeRef.value.checked = true
      inActiveRef.value.checked = false
    } else {
      inActiveRef.value.checked = true
      activeRef.value.checked = false
    }
  }, {
    immediate: true

  })
})

function onClickActive() {
  if (props.disabled) {
    return
  }
  value.value = true

}

function onClickInactive() {
  if (props.disabled) {
    return
  }
  value.value = false
}


</script>



<style scoped>
.et-switch {
  user-select: none;
}
.et-switch label {
  font-weight: normal;
}
.et-switch input[type="radio"] {
  display: none;
}
.et-switch input:checked ~ span {
  background-color: #178FFC;
}
.et-switch span {
  padding: 4px;
  border: 1px solid #178FFC;
  cursor: pointer;
}
</style>
